<template>
  <header id="header">
    <div class="sscontainer">
      <menu-burger-mobile></menu-burger-mobile>

      <div class="menu-block">
        <logo-lien-header></logo-lien-header>
      </div>
      <div class="menu-block">
        <div class="menu-icons">
          <menu-base-sinscrire></menu-base-sinscrire>
          <menu-base-se-connecter></menu-base-se-connecter>
          <menu-base-aide></menu-base-aide>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header-sign',
}
</script>
